module.exports = __webpack_public_path__ + "img/reload.1021d02a.svg";